<template>
	<v-menu auto>
		<template v-slot:activator="{ on }">
			<v-btn class="menu-icon" icon @click.stop="on.click">
				<v-icon>fas fa-ellipsis-v</v-icon>
			</v-btn>
		</template>

		<v-list>
			<v-list-item @click="fnRenameItem(item)">
				<v-list-item-title>Rename</v-list-item-title>
			</v-list-item>

			<v-list-item
				v-if="!isRoom(item)"
				:disabled="isController(item)"
				@click="fnMoveItem(item)"
			>
				<v-list-item-title>Move</v-list-item-title>
			</v-list-item>

			<v-divider />

			<div
				@click="
					!isEmptyRoom(item)
						? $emit('update:showDeleteRoomSnackbar', true)
						: null
				"
			>
				<v-list-item
					:disabled="!isEmptyRoom(item) || isController(item)"
					@click="fnRemoveItem(item)"
				>
					<v-list-item-title>Remove</v-list-item-title>
				</v-list-item>
			</div>
		</v-list>
	</v-menu>
</template>

<style lang="scss" scoped>
.device-list--item {
	.menu-icon {
		opacity: 0;
		transition: opacity 300ms;
	}

	&:hover .menu-icon {
		opacity: 1;
	}
}
</style>

<script>
export default {
	props: [
		"item",
		"fnRemoveItem",
		"fnRenameItem",
		"fnMoveItem",
		"isRoom",
		"isEmptyRoom",
		"isController",
	],
};
</script>
